import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Config } from "constant";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import Input from "module-common/Input";
import { ShowNotice } from "Store";

export default class ConfirmModal extends Component {
  static propTypes = {
    text: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    isConfirmLoading: PropTypes.bool
  };
  static defaultProps = {
    isConfirmLoading: false
  };
  state = {
    app_name: "",
    channel_id: "",
    channel_secret: "",
    channel_access_token: ""
  };

  render() {
    const { text, onCancel, isConfirmLoading } = this.props;
    const {
      app_name,
      channel_id,
      channel_secret,
      channel_access_token
    } = this.state;
    return (
      <Modal>
        <Wrapper>
          <Text>{text}</Text>
          <Label>App Name</Label>
          <Input
            label="App Name"
            name="app_name"
            value={app_name}
            onChange={e => this.setState({ app_name: e.target.value })}
          />
          <Label>Channel ID</Label>
          <Input
            label="Channel ID"
            name="channel_id"
            value={channel_id}
            onChange={e => this.setState({ channel_id: e.target.value })}
          />
          <Label>Channel Secret</Label>
          <Input
            label="Channel Secret"
            name="channel_secret"
            value={channel_secret}
            onChange={e => this.setState({ channel_secret: e.target.value })}
          />
          <Label>Channel Access Token</Label>
          <Input
            label="Channel Access Token"
            name="channel_access_token"
            value={channel_access_token}
            onChange={e =>
              this.setState({ channel_access_token: e.target.value })
            }
          />
          <Buttons>
            <Button
              width={100}
              onClick={onCancel}
              color="gray"
              disabled={isConfirmLoading}
            >
              Cancel
            </Button>
            <Button
              width={100}
              onClick={this.onConfirm}
              loading={isConfirmLoading}
              disabled={isConfirmLoading}
            >
              Add LINE
            </Button>
          </Buttons>
        </Wrapper>
      </Modal>
    );
  }

  onConfirm = e => {
    e.preventDefault();
    const {
      app_name,
      channel_id,
      channel_secret,
      channel_access_token
    } = this.state;
    const onConfirm = this.props.onConfirm;
    if (
      app_name === "" ||
      channel_id === "" ||
      channel_secret === "" ||
      channel_access_token === ""
    ) {
      ShowNotice("channel-add-error");
    } else {
      fetch(`${Config.apiUrl}/authorize/chat_platform/line`, {
        method: "post",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: app_name,
          client_id: channel_id,
          client_secret: channel_secret,
          access_token: channel_access_token
        })
      }).then(response => {
        ShowNotice("channel-add-success");
        onConfirm(this.state.app_name);
        window.location.reload();
      });
    }
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 10px;
`;
const Label = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 0.8rem;
  margin-top: 10px;
  margin-left: 2px;
`;
const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/LineModal.js